import { render, staticRenderFns } from "./InitialSetupView.vue?vue&type=template&id=0149e25f&"
import script from "./InitialSetupView.vue?vue&type=script&lang=js&"
export * from "./InitialSetupView.vue?vue&type=script&lang=js&"
import style0 from "./InitialSetupView.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports